<template lang="pug">
  svg.icon(xmlns="http://www.w3.org/2000/svg", :class="icon[name].c + customClass",
  :width="icon[name].w", :height="icon[name].h")
    template(v-if="name === 'ticketButtonHover' || name === 'ticketButtonHoverLong'")
      path(:d="icon[name].hover.d" :fill="colorize ? '': color" class="hover")
    path(:d="icon[name].d" :fill="colorize ? '' : color")
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    primary: {
      type: Boolean,
      required: false,
      default: false,
    },
    secondary: {
      type: Boolean,
      required: false,
      default: false,
    },
    thirdly: {
      type: Boolean,
      required: false,
      default: false,
    },
    left: {
      type: Boolean,
      required: false,
      default: false,
    },
    right: {
      type: Boolean,
      required: false,
      default: false,
    },
    revers: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default: '#151515',
    },
  },
  data: () => ({
    customClass: '',
    colorize: false,
    icon: {
      leftCalendar: {
        c: 'icon_left_calendar',
        w: 8,
        h: 13,
        d: 'M6.517 12.984a.722.722 0 0 0 .512-1.233L1.748 6.484l5.282-5.27A.724.724 0 0 0 6.006.192L.212 5.974a.722.722 0 0 0 0 1.022l5.794 5.782c.136.133.32.207.511.206z',
      },
      rightCalendar: {
        c: 'icon_right_calendar',
        w: 8,
        h: 13,
        d: 'M.724 12.995a.722.722 0 0 1-.512-1.233L5.494 6.49.212 1.22A.724.724 0 0 1 1.237.199L7.031 5.98a.722.722 0 0 1 0 1.022l-5.794 5.782a.724.724 0 0 1-.513.21z',
      },
      bigCalendar: {
        c: 'icon_big_calendar',
        w: 16,
        h: 16,
        d: 'M12 1.6h3.2a.8.8 0 0 1 .8.8v12.8a.8.8 0 0 1-.8.8H.8a.8.8 0 0 1-.8-.8V2.4a.8.8 0 0 1 .8-.8H4V0h1.6v1.6h4.8V0H12v1.6zM14.4 8H1.6v6.4h12.8V8zm-4-4.8H5.6v1.6H4V3.2H1.6v3.2h12.8V3.2H12v1.6h-1.6V3.2z',
      },
      closeDayCalendar: {
        c: 'icon_close_day_calendar',
        w: 7,
        h: 7,
        d: 'M3.494 2.33L5.823 0l1.165 1.165-2.33 2.329 2.33 2.329-1.165 1.165-2.329-2.329-2.329 2.329L0 5.823l2.33-2.329L0 1.165 1.165 0l2.329 2.33z',
      },
      ratingStarFull: {
        c: 'icon_rating-star icon_rating-star-full',
        w: 12.018,
        h: 11.979,
        d: 'M2.253 11.98a.75.75 0 0 1-.711-.99l1.155-3.385-2.49-2.594A.748.748 0 0 1 .75 3.745h3.247L5.31.472a.752.752 0 0 1 1.4 0l1.313 3.273h3.247a.748.748 0 0 1 .565 1.242l-2.3 2.619.959 3.425a.748.748 0 0 1-.268.8.757.757 0 0 1-.842.047L6.012 9.857l-3.369 2.016a.751.751 0 0 1-.39.107z',
      },
      ratingStar: {
        c: 'icon_rating-star',
        w: 12.018,
        h: 11.979,
        d: 'M2.253 11.98a.75.75 0 0 1-.711-.99l1.155-3.385-2.49-2.594A.748.748 0 0 1 .75 3.745h3.247L5.31.472a.752.752 0 0 1 1.4 0l1.313 3.273h3.247a.748.748 0 0 1 .565 1.242l-2.3 2.619.959 3.425a.747.747 0 0 1-.268.8.756.756 0 0 1-.842.047L6.012 9.857l-3.369 2.016a.751.751 0 0 1-.39.107zm3.759-3.744a.751.751 0 0 1 .386.107l2.139 1.279-.561-2.005a.746.746 0 0 1 .159-.695l1.478-1.681h-2.1a.752.752 0 0 1-.7-.471l-.8-2.006-.8 2.006a.751.751 0 0 1-.7.471h-2l1.59 1.657a.748.748 0 0 1 .168.759l-.642 1.88 2-1.195a.752.752 0 0 1 .383-.106z',
      },
      crossSmall: {
        c: 'icon_cross-small',
        w: 6.02,
        h: 6.02,
        d: 'M3.01 3.762L.752 6.02 0 5.268 2.258 3.01 0 .752.752 0 3.01 2.258 5.268 0l.752.752L3.763 3.01l2.258 2.258-.752.752z',
      },
      favoriteSmall: {
        c: 'icon_favorite-small',
        w: 9,
        h: 12.002,
        d: 'M8.25 12.002a.75.75 0 0 1-.468-.164L4.5 9.208l-3.282 2.626A.75.75 0 0 1 0 11.248V1.496a1.5 1.5 0 0 1 1.5-1.5h6a1.5 1.5 0 0 1 1.5 1.5v9.752a.75.75 0 0 1-.75.75zm-3.75-4.5a.748.748 0 0 1 .468.164L7.5 9.691V1.5h-6v8.191l2.532-2.025a.748.748 0 0 1 .468-.165z',
      },
      phoneSmall: {
        c: 'icon_phone-small',
        w: 9,
        h: 12,
        d: 'M1.5 12A1.5 1.5 0 0 1 0 10.5v-9A1.5 1.5 0 0 1 1.5 0h6A1.5 1.5 0 0 1 9 1.5v9A1.5 1.5 0 0 1 7.5 12zm0-1.5h6v-9h-6zm2.249-1.75a.75.75 0 0 1 0-1.5h1.5a.75.75 0 1 1 0 1.5z',
      },
      locationSmall: {
        c: 'icon_location-small',
        w: 12,
        h: 14,
        d: 'M0 6.124a6 6 0 1 1 12 0 8.446 8.446 0 0 1-2.811 6.05A6.2 6.2 0 0 1 6 14c-1.242 0-6-2.958-6-7.876zm1.714 0c0 3.815 3.731 6.035 4.324 6.127.518-.092 4.248-2.312 4.248-6.127a4.287 4.287 0 1 0-8.572 0zm1.715 0A2.572 2.572 0 1 1 6 8.75a2.6 2.6 0 0 1-2.572-2.626zm1.714 0A.857.857 0 1 0 6 5.249a.868.868 0 0 0-.857.875z',
      },
      ticketButtonHover: {
        c: 'icon_ticket',
        w: 60,
        h: 30,
        d: 'M2 1c-.552 0-1 .448-1 1v5.26c0 .451.31.847.755.962A6.997 6.997 0 0 1 7 15a6.997 6.997 0 0 1-5.245 6.777.999.999 0 0 0-.755.963V28c0 .55.448 1 1 1h56c.551 0 1-.45 1-1v-5.26a.999.999 0 0 0-.755-.963A6.997 6.997 0 0 1 53 15a6.997 6.997 0 0 1 5.245-6.778A.999.999 0 0 0 59 7.26V2c0-.552-.449-1-1-1H2zm0-1h56a2 2 0 0 1 2 2v5.26c0 .912-.621 1.701-1.505 1.93a6.002 6.002 0 0 0 0 11.62A1.996 1.996 0 0 1 60 22.74V28a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-5.26c0-.913.62-1.702 1.505-1.93a6.003 6.003 0 0 0 0-11.62A1.996 1.996 0 0 1 0 7.26V2a2 2 0 0 1 2-2z',
        hover: {
          d: 'M1 1h58v7l-2 1-2 2-1 2-1 2 1 2 1 2 2 2 2 1v7H1v-7l2-1 2-2 1-2 1-2-1-2-1-2-2-2-2-1V1z',
        },
      },
      ticketButtonHoverLong: {
        c: 'icon_ticket',
        w: 72,
        h: 30,
        d: 'M 2 1 C 1.448 1 1 1.448 1 2 L 1 7.26 C 1 7.711 1.31 8.107 1.755 8.222 C 4.844 9.021 7.002 11.809 7 15 C 7.001 18.191 4.844 20.978 1.755 21.777 C 1.313 21.888 1.003 22.284 1 22.74 L 1 28 C 1 28.55 1.448 29 2 29 L 70.328 29.179 C 70.879 29.179 71.328 28.729 71.328 28.179 L 71.328 22.919 C 71.325 22.463 71.015 22.067 70.573 21.956 C 67.484 21.157 65.327 18.37 65.328 15.179 C 65.326 11.988 67.484 9.2 70.573 8.401 C 71.014 8.29 71.325 7.894 71.328 7.439 L 71.328 2.179 C 71.328 1.627 70.879 1.179 70.328 1.179 L 2 1 Z M 2 0 L 70.328 0.179 C 71.433 0.179 72.328 1.074 72.328 2.179 L 72.328 7.439 C 72.328 8.351 71.707 9.14 70.823 9.369 C 66.35 10.528 64.81 16.095 68.05 19.388 C 68.813 20.163 69.771 20.716 70.823 20.989 C 71.707 21.213 72.326 22.007 72.328 22.919 L 72.328 28.179 C 72.328 29.284 71.433 30.179 70.328 30.179 L 2 30 C 0.895 30 0 29.105 0 28 L 0 22.74 C 0 21.827 0.62 21.038 1.505 20.81 C 5.978 19.648 7.515 14.08 4.272 10.787 C 3.511 10.015 2.555 9.463 1.505 9.19 C 0.621 8.966 0.002 8.172 0 7.26 L 0 2 C 0 0.895 0.895 0 2 0 Z',
        hover: {
          d: 'M 0.563 1.009 L 71.427 1.009 L 71.427 8.076 L 69.427 9.086 L 67.427 11.105 L 66.427 13.124 L 65.427 15.143 L 66.427 17.162 L 67.427 19.181 L 69.427 21.2 L 71.427 22.21 L 71.427 29.277 L 0.563 29.277 L 0.563 22.21 L 2.563 21.2 L 4.563 19.181 L 5.563 17.162 L 6.563 15.143 L 5.563 13.124 L 4.563 11.105 L 2.563 9.086 L 0.563 8.076 L 0.563 1.009 Z',
        },
      },
      ticketButton: {
        c: 'icon_ticket',
        w: 60,
        h: 30,
        d: 'M2 1c-.552 0-1 .448-1 1v5.26c0 .451.31.847.755.961A6.998 6.998 0 0 1 7 15a6.997 6.997 0 0 1-5.245 6.777.999.999 0 0 0-.755.962V28c0 .552.448 1 1 1h56c.551 0 1-.448 1-1v-5.26a.998.998 0 0 0-.755-.961A6.997 6.997 0 0 1 53 15a6.998 6.998 0 0 1 5.245-6.779A.998.998 0 0 0 59 7.26V2c0-.552-.449-1-1-1H2m0-1h56a2 2 0 0 1 2 2v5.26c0 .912-.621 1.702-1.505 1.93a6.003 6.003 0 0 0 0 11.62A1.996 1.996 0 0 1 60 22.74V28a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-5.26c0-.913.62-1.702 1.505-1.93a6.003 6.003 0 0 0 0-11.62A1.995 1.995 0 0 1 0 7.26V2a2 2 0 0 1 2-2z',
      },
      ticketButtonLong: {
        c: 'icon_ticket',
        w: 72,
        h: 30,
        d: 'M 2 1 C 1.448 1 1 1.448 1 2 L 1 7.26 C 1 7.711 1.31 8.107 1.755 8.222 C 4.844 9.021 7.002 11.809 7 15 C 7.001 18.191 4.844 20.978 1.755 21.777 C 1.313 21.888 1.003 22.284 1 22.74 L 1 28 C 1 28.55 1.448 29 2 29 L 70.328 29.179 C 70.879 29.179 71.328 28.729 71.328 28.179 L 71.328 22.919 C 71.325 22.463 71.015 22.067 70.573 21.956 C 67.484 21.157 65.327 18.37 65.328 15.179 C 65.326 11.988 67.484 9.2 70.573 8.401 C 71.014 8.29 71.325 7.894 71.328 7.439 L 71.328 2.179 C 71.328 1.627 70.879 1.179 70.328 1.179 L 2 1 Z M 2 0 L 70.328 0.179 C 71.433 0.179 72.328 1.074 72.328 2.179 L 72.328 7.439 C 72.328 8.351 71.707 9.14 70.823 9.369 C 66.35 10.528 64.81 16.095 68.05 19.388 C 68.813 20.163 69.771 20.716 70.823 20.989 C 71.707 21.213 72.326 22.007 72.328 22.919 L 72.328 28.179 C 72.328 29.284 71.433 30.179 70.328 30.179 L 2 30 C 0.895 30 0 29.105 0 28 L 0 22.74 C 0 21.827 0.62 21.038 1.505 20.81 C 5.978 19.648 7.515 14.08 4.272 10.787 C 3.511 10.015 2.555 9.463 1.505 9.19 C 0.621 8.966 0.002 8.172 0 7.26 L 0 2 C 0 0.895 0.895 0 2 0 Z',
      },
      star: {
        c: 'icon_star',
        w: 8.001,
        h: 8.004,
        d: 'M4.001 6.415L1.528 8.006 2.2 5.042 0 3.06l2.888-.244L4.001 0l1.113 2.814 2.888.244-2.2 1.982.672 2.964z',
      },
      playVideo: {
        c: 'icon_play-video',
        w: 42,
        h: 42,
        d: 'M21 .002a21 21 0 1 0 21 21 21 21 0 0 0-21-21zm7.258 22.113l-10.5 6.563a1.313 1.313 0 0 1-2.008-1.112V14.438a1.313 1.313 0 0 1 2.008-1.113l10.5 6.562a1.313 1.313 0 0 1 0 2.226z',
      },
      close: {
        c: 'icon_close',
        w: 12.963,
        h: 12.963,
        d: 'M6.481 5.041L11.523 0l1.44 1.44-5.042 5.042 5.042 5.041-1.44 1.44-5.042-5.042-5.041 5.042L0 11.523l5.042-5.041L0 1.44 1.44 0z',
      },
      leftSmall: {
        c: 'icon_left-small',
        w: 7.24,
        h: 13.01,
        d: 'M6.52 13a.72.72 0 0 0 .51-1.23L1.75 6.51l5.28-5.27A.72.72 0 0 0 6.01.2L.2 6a.72.72 0 0 0 0 1.02l5.8 5.78a.72.72 0 0 0 .5.2z',
      },
      rightSmall: {
        c: 'icon_right-small',
        w: 7.24,
        h: 13.01,
        d: 'M.72 13a.72.72 0 0 1-.5-1.23L5.48 6.5.21 1.23A.72.72 0 0 1 1.24.21l5.79 5.78a.72.72 0 0 1 0 1.02l-5.8 5.79a.72.72 0 0 1-.5.2z',
      },
      ticket: {
        c: 'icon_ticket',
        w: 10,
        h: 9,
        d: 'M6 0v9H.5a.5.5 0 0 1-.5-.5V5.75a1.25 1.25 0 0 0 0-2.5V.5A.5.5 0 0 1 .5 0zm1 0h2.5a.5.5 0 0 1 .5.5v2.75a1.25 1.25 0 0 0 0 2.5V8.5a.5.5 0 0 1-.5.5H7z',
      },
      ticketStock: {
        c: 'icon_ticket-stock',
        w: 25,
        h: 22,
        d: 'M14 3v18H3a1 1 0 0 1-1-1v-5.5a2.5 2.5 0 1 0 0-5V4a1 1 0 0 1 1-1h11zm2 0h5a1 1 0 0 1 1 1v5.5a2.5 2.5 0 1 0 0 5V20a1 1 0 0 1-1 1h-5V3z',
      },
      calendar: {
        c: 'icon_calendar',
        w: 16,
        h: 15,
        d: 'M12 1.6h3.2a.8.8 0 0 1 .8.8v11.8a.8.8 0 0 1-.8.8H.8a.8.8 0 0 1-.8-.8V2.4a.8.8 0 0 1 .8-.8H4V0h1.6v1.6h4.8V0H12zM14.4 8H1.6v5.4h12.8zm-4-4.8H5.6v1.6H4V3.2H1.6v3.2h12.8V3.2H12v1.6h-1.6z',
      },
      downArrow: {
        c: 'icon_down-arrow',
        w: 5.963,
        h: 4,
        d: 'M2.981 4.003a.562.562 0 0 1-.422-.2L.174 1.137a.724.724 0 0 1 0-.943.553.553 0 0 1 .843 0l1.964 2.2 1.964-2.2a.553.553 0 0 1 .843 0 .723.723 0 0 1 0 .943L3.4 3.803a.562.562 0 0 1-.419.2z',
      },
      rightArrow: {
        c: 'icon_right-arrow',
        w: 32,
        h: 30,
        d: 'M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z',
      },
      location: {
        c: 'icon_location',
        w: 13,
        h: 16,
        d: 'M6.505 13.926l3.578-3.647a5.229 5.229 0 0 0 0-7.294 4.991 4.991 0 0 0-7.155 0 5.229 5.229 0 0 0 0 7.294zm0 2.083l-4.6-4.688a6.723 6.723 0 0 1 0-9.378 6.417 6.417 0 0 1 9.2 0 6.723 6.723 0 0 1 0 9.378zm0-7.9A1.474 1.474 0 1 0 5.06 6.635a1.46 1.46 0 0 0 1.445 1.47zm0 1.473a2.948 2.948 0 1 1 2.891-2.948 2.919 2.919 0 0 1-2.891 2.944z',
      },
      mobile: {
        c: 'icon_mobile',
        w: 14,
        h: 20,
        d: 'M2 2.001v16h10v-16zm-1-2h12a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-18a1 1 0 0 1 1-1zm6 15a1 1 0 1 1-1 1 1 1 0 0 1 1-1z',
      },
      phone: {
        c: 'icon_phone',
        w: 18,
        h: 18,
        d: 'M6.366 7.682a10.554 10.554 0 0 0 3.952 3.952l.884-1.237a1 1 0 0 1 1.294-.3 11.426 11.426 0 0 0 4.583 1.364 1 1 0 0 1 .921 1v4.462a1 1 0 0 1-.9.995A15.509 15.509 0 0 1 .08.898a1 1 0 0 1 .995-.9h4.462a1 1 0 0 1 1 .921 11.423 11.423 0 0 0 1.364 4.583 1 1 0 0 1-.3 1.294zm-2.522-.656l1.9-1.357a13.406 13.406 0 0 1-1.1-3.668H2.01c-.006.167-.009.334-.009.5a13.5 13.5 0 0 0 13.5 13.5c.167 0 .334 0 .5-.01v-2.637a13.4 13.4 0 0 1-3.668-1.1l-1.357 1.9a12.525 12.525 0 0 1-1.588-.75l-.058-.033a12.551 12.551 0 0 1-4.7-4.7l-.033-.058a12.5 12.5 0 0 1-.753-1.588z',
      },
      left: {
        c: 'icon_left',
        w: 7.25,
        h: 13,
        d: 'M6.518 13.007a.722.722 0 0 0 .512-1.233L1.748 6.507l5.282-5.27A.724.724 0 0 0 6.006.215L.212 5.997a.722.722 0 0 0 0 1.022l5.794 5.782a.72.72 0 0 0 .512.206z',
      },
      right: {
        c: 'icon_right',
        w: 7.25,
        h: 13,
        d: 'M.725 13.007a.722.722 0 0 1-.512-1.233l5.282-5.272-5.282-5.27A.724.724 0 0 1 1.237.21l5.794 5.782a.722.722 0 0 1 0 1.022l-5.794 5.782a.721.721 0 0 1-.512.211z',
      },
      search: {
        c: 'icon_search',
        w: 15.92,
        h: 16,
        d: 'M14.215 15.703l-3.938-3.961a6.407 6.407 0 0 1-3.812 1.253 6.493 6.493 0 1 1 5.219-2.668l3.938 3.961a1 1 0 0 1 0 1.414.992.992 0 0 1-1.407 0zM1.988 6.495a4.476 4.476 0 1 0 4.476-4.5 4.493 4.493 0 0 0-4.475 4.508z',
      },
      user: {
        c: 'icon_user',
        w: 11,
        h: 15,
        d: 'M.691 15.001h-.69v-1.43A3.507 3.507 0 0 1 3.439 10h4.125a3.507 3.507 0 0 1 3.437 3.571v1.43h-.69zm8.935-1.44a2.1 2.1 0 0 0-2.063-2.133H3.438a2.1 2.1 0 0 0-2.063 2.133zm-8.25-9.275a4.128 4.128 0 1 1 4.125 4.286 4.207 4.207 0 0 1-4.125-4.286zm1.375 0a2.752 2.752 0 1 0 2.75-2.857 2.805 2.805 0 0 0-2.75 2.857z',
      },
      vk: {
        c: 'icon_vk',
        w: 19.863,
        h: 11.879,
        d: 'M7.253 0h4.063a.261.261 0 0 1 .3.294v5.091c.1.293.2.391.5.293a2.157 2.157 0 0 0 .5-.391 13.174 13.174 0 0 0 2.18-3.035l.892-1.763c.1-.2.2-.2.5-.2a8.86 8.86 0 0 0 2.279 0c.594-.1.991.2.793.686a22.085 22.085 0 0 1-1.09 2.154c-.5.881-1.09 1.762-1.685 2.643-.4.587-.4.686.1 1.175l2.378 2.644a4.041 4.041 0 0 1 .694 1.077c.1.1.1.293.2.391.1.392-.1.686-.595.686h-2.676c-.1 0-.2-.1-.3-.2-.892-.881-1.685-1.763-2.577-2.545a2.389 2.389 0 0 0-1.189-.686c-.4-.1-.694 0-.694.49v1.958c0 .783-.2.979-.991 1.077a6.884 6.884 0 0 1-5.054-1.664 12.034 12.034 0 0 1-3.072-3.623 18.986 18.986 0 0 1-2.477-4.9c-.1-.294-.1-.587-.2-.881-.1-.49.2-.784.793-.784a10.461 10.461 0 0 0 2.478 0c.3 0 .3 0 .4.2a18.108 18.108 0 0 0 1.685 4.014 7.86 7.86 0 0 0 1.982 2.35c.2.1.3 0 .4-.2V2.434a2.322 2.322 0 0 0-.5-1.37 2.281 2.281 0 0 1-.2-.783C7.055.098 7.154 0 7.253 0z',
      },
      fb: {
        c: 'icon_fb',
        w: 7.991,
        h: 15,
        d: 'M5.106 15.001H1.831v-7.5H-.003V4.876h1.834v-2.25A2.766 2.766 0 0 1 4.451.001h3.144v2.625H5.761a.551.551 0 0 0-.524.5v1.75h2.751a18.163 18.163 0 0 0-.393 2.625H5.106z',
      },
      twitter: {
        c: 'icon_twitter',
        w: 20,
        h: 18,
        d: 'M20 2.8a8.489 8.489 0 0 1-2.36.64 4.132 4.132 0 0 0 1.81-2.27 8.212 8.212 0 0 1-2.61 1 4.1 4.1 0 0 0-7 3.74 11.64 11.64 0 0 1-8.45-4.29 4.164 4.164 0 0 0-.55 2.07A4.09 4.09 0 0 0 2.66 7.1 4.057 4.057 0 0 1 .8 6.59v.05a4.1 4.1 0 0 0 3.3 4 3.908 3.908 0 0 1-1.1.17 4.845 4.845 0 0 1-.77-.07 4.111 4.111 0 0 0 3.83 2.84A8.22 8.22 0 0 1 0 15.28a11.57 11.57 0 0 0 6.29 1.85c6.401.066 11.643-5.068 11.71-11.469V5.45v-.53a8.437 8.437 0 0 0 2-2.12z',
      },
      instagram: {
        c: 'icon_instagram',
        w: 15,
        h: 15,
        d: 'M3.8 14.946a5.015 5.015 0 0 1-1.7-.315 3.027 3.027 0 0 1-1.736-1.735 5.066 5.066 0 0 1-.315-1.7c-.044-.964-.053-1.254-.053-3.7s.009-2.732.053-3.7a5.063 5.063 0 0 1 .315-1.7A3.029 3.029 0 0 1 2.1.36 5.05 5.05 0 0 1 3.8.045c.964-.044 1.253-.053 3.7-.053s2.732.009 3.7.054a5.03 5.03 0 0 1 1.7.314 3.029 3.029 0 0 1 1.736 1.736 5.041 5.041 0 0 1 .314 1.7c.045.964.053 1.254.053 3.7s-.008 2.733-.053 3.7a5.1 5.1 0 0 1-.314 1.7 3.035 3.035 0 0 1-1.736 1.735 5.02 5.02 0 0 1-1.7.315c-.965.045-1.254.054-3.7.054s-2.732-.009-3.7-.054zM2.8 7.5a4.7 4.7 0 1 0 4.7-4.7 4.7 4.7 0 0 0-4.7 4.701zm8.484-4.883a1.1 1.1 0 1 0 1.1-1.1 1.1 1.1 0 0 0-1.098 1.1zM4.448 7.502a3.05 3.05 0 1 1 3.05 3.05A3.051 3.051 0 0 1 4.45 7.501z',
      },
      playBox: {
        c: 'icon_play-box',
        w: '10',
        h: '10',
        d: 'M0 .551A.552.552 0 0 1 .552 0h8.9a.552.552 0 0 1 .552.551v8.9a.553.553 0 0 1-.552.552h-8.9A.553.553 0 0 1 0 9.451zm4.234 2.457a.222.222 0 0 0-.308.061.219.219 0 0 0-.037.123v3.614a.222.222 0 0 0 .346.184l2.711-1.806a.223.223 0 0 0 .062-.309.225.225 0 0 0-.062-.062L4.235 3.007z',
      },
      clock: {
        c: 'icon_clock',
        w: '10',
        h: '10',
        d: 'M5 10.002a5 5 0 1 1 5-5 5 5 0 0 1-5 5zm0-5v-2H4v3h3v-1z',
      },
      train: {
        c: 'icon_train',
        w: '18',
        h: '20',
        d: 'M14.2 17l1.8 1.5v.5a1 1 0 01-1 1H3a1 1 0 01-1-1v-.5L3.8 17H2a2 2 0 01-2-2V4a4 4 0 014-4h10a4 4 0 014 4v11a2 2 0 01-2 2zM8 8V2H4a2 2 0 00-2 2v4a1 1 0 001 1h4a1 1 0 001-1zm3 1h4a1 1 0 001-1V4a2 2 0 00-2-2h-4v6a1 1 0 001 1zm-6.5 6A1.5 1.5 0 103 13.5 1.5 1.5 0 004.5 15zm9 0a1.5 1.5 0 10-1.5-1.5 1.5 1.5 0 001.5 1.5z',
      },
      transfer: {
        c: 'icon_transfer',
        w: '18',
        h: '18',
        d: 'M17.973 8.537v8.538a.925.925 0 01-.9.949h-.9a.925.925 0 01-.9-.949v-.949H2.696v.949a.925.925 0 01-.9.949h-.9a.925.925 0 01-.9-.949V8.537l2.229-5.491a1.8 1.8 0 011.653-1.15h2.411v-1.9h5.392v1.9h2.408a1.8 1.8 0 011.652 1.15zm-16.018 0h14.063l-1.926-4.743H3.882L1.956 8.537zm2.089 4.743a1.425 1.425 0 10-1.348-1.423 1.387 1.387 0 001.348 1.423zm9.886 0a1.425 1.425 0 10-1.348-1.423 1.387 1.387 0 001.347 1.423z',
      },
    },
  }),
  mounted() {
    if (this.primary) {
      this.customClass += ' icon_color-primary';
      this.colorize = true;
    }
    if (this.secondary) {
      this.customClass += ' icon_color-secondary';
      this.colorize = true;
    }
    if (this.thirdly) {
      this.customClass += ' icon_color-thirdly';
      this.colorize = true;
    }
    if (this.left) {
      this.customClass += ' icon_space-left';
    }
    if (this.right) {
      this.customClass += ' icon_space-right';
    }
    if (this.revers) {
      this.customClass += ' icon_revers';
    }
  },
  watch: {
    revers(val) {
      if (!val) {
        this.customClass = this.customClass.replace(/icon_revers/gi, '');
      } else {
        this.customClass += ' icon_revers';
      }
    },
  },
};
</script>
